import { GetRowIdParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useCallback, useRef } from 'react';
import { useAtomValue } from 'jotai';
import { AgTable } from '../../../components/AgTable/AgTable';
import { useExtendedExportSettings } from '../../../components/AgTable/exportToExcelDefs';
import { FadeInGridWrapper } from '../../../components/grid-renderers/FadeInGridWrapper';
import { SecurityReport } from '../../../schemas/SecurityReport.schema';
import { securityReportState } from '../state/FinanceStateJotai';
import {
  AllSecuritiesAutoGroupColDef,
  AllSecuritiesDefaultColDefs,
  useAllSecuritiesColDefs,
} from './AllSecuritiesColDefs';
import { useAllSecuritiesFilterState } from './AllSecuritiesFilterState';

export function AllSecuritiesGrid() {
  const gridRef = useRef<AgGridReact>(null);
  const columnDefs = useAllSecuritiesColDefs();
  const data = useAtomValue(securityReportState);
  const { exportParams } = useExtendedExportSettings(new Set(['companyId', 'fundId']), 'All Securities');
  const { doesExternalFilterPass, isExternalFilterPresent } = useAllSecuritiesFilterState(gridRef);

  const getRowId = useCallback(
    (params: GetRowIdParams) => `${params.data?.restructureId ?? ''}::${params.data?.fundId ?? -1}`,
    []
  );

  return (
    <>
      <div style={{ paddingTop: '1rem', height: '72vh' }}>
        <FadeInGridWrapper>
          <AgTable
            ref={gridRef}
            columnDefs={columnDefs}
            rowData={data as SecurityReport[]}
            defaultColDef={AllSecuritiesDefaultColDefs}
            autoGroupColumnDef={AllSecuritiesAutoGroupColDef}
            defaultCsvExportParams={exportParams}
            defaultExcelExportParams={exportParams}
            groupDefaultExpanded={-1}
            doesExternalFilterPass={doesExternalFilterPass}
            isExternalFilterPresent={isExternalFilterPresent}
            suppressAggFuncInHeader={true}
            getRowId={getRowId}
            grandTotalRow='bottom'
          />
        </FadeInGridWrapper>
      </div>
    </>
  );
}
